/* eslint-disable no-console */
/* eslint-disable quotes */
import React, { Component } from "react";
import "../../css/pages/customers.css";
import "../../css/pages/dropdown.css";
import { Link } from "react-router-dom";
import moment from "moment";
import Nav from "react-bootstrap/esm/Nav";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import * as FileSaver from "file-saver";
import SideNav from "../components/SideNav";
import TopNav from "../components/TopNav";
import {
  fetchLoan,
  fetchLoanSchedules,
  fetchBorrowerDetails,
  fetchInsuranceBusiness,
} from "../actions/p2p";

import AcceptLoan from "../components/modals/AcceptLoan";
import EditLoan from "../components/modals/EditLoan";
import CancelLoan from "../components/modals/CancelLoan";
import LoanScheduleTransactions from "../components/modals/LoanScheduleTransactions";

import { fillUser } from "../actions/account";

class ViewInsurance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedules: [],
      edit: false,
      cancel: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    try {
      const { data } = fetchInsuranceBusiness(match.params.id)
        .then(({ data }) => {
          console.log({ data }, "czxs");
          this.setState({
            singleInsurance: data,
          });
        })
        .catch(() =>
          toast.error(
            "An error occured fetching insurance stats on your account."
          )
        );
    } catch (e) {
      return e;
    }
  }

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      user,
      history,
    } = this.props;
    const { singleInsurance } = this.state;

    console.log({ singleInsurance });
    console.log(singleInsurance?.[0]?.asset?.asset_documents);
    const assetDocuments = singleInsurance?.[0]?.asset?.asset_documents;
    const assetAttributeValues =
      singleInsurance?.[0]?.asset?.asset_attribute_values;
    const product = singleInsurance?.[0]?.asset?.product;
    console.log({ product });

    const details = [];
    details.push(
      {
        title: "Name",
        description: `${product?.name}`,
      },
      {
        title: "Description",
        description: `${product?.description}`,
      },
      {
        title: "Type",
        description: `${product?.type}`,
      },
      {
        title: "Value type",
        description: `${product?.value_type}`,
      },
      {
        title: "Date Disbursed",
        description: `${
          product?.created_on
            ? moment(product?.created_on).format("MMM DD, YYYY, h:mm:ss a")
            : "-"
        }`,
      }
    );

    return (
      <>
        <SideNav page="insurance" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="insurance" />
            <section className="body-main__content">
              <div className="loans">
                <div className="pageTitle d-lg-none">
                  {/* <h3 className="pageTitle__header">Loan Details</h3> */}
                </div>
                <div className="row">
                  <div className="col">
                    <div className="">
                      {!!details.length && (
                        <div className="card default-card page-table mb-5">
                          <div className="row">
                            <Nav className="nav nav-tabs" as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                  className="nav-link active p-0"
                                  eventKey="profile"
                                >
                                  Product
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            {details.map((detail) => (
                              <div
                                className="col-12 col-md-3 pt-5"
                                key={detail.title}
                              >
                                <div>
                                  <h6 className="fw-bold">{detail.title}</h6>
                                  <p className="mb-8">{detail.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

  
                      <div className="row">
                        <div className="col" id="exportSchedule">
                          <div className="card default-card settings">
                            <Nav className="nav nav-tabs" as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                  className="nav-link active"
                                  eventKey="profile"
                                >
                                  Asset Documents
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            {assetDocuments && (
                              <div className="tab-content">
                                <div className="tab-pane fade show active">
                                  <div className="table-responsive">
                                    <table
                                      className="table"
                                      style={{ textAlign: "center" }}
                                    >
                                      <thead className="bg-secondary">
                                        <tr>
                                          {/* <th className="sn text-white">S/N</th> */}
                                          <th className="date-time text-white">
                                            Asset ID
                                          </th>
                                          <th className="loan_amount text-white">
                                            User ID
                                          </th>
                                          <th className="interest text-white">
                                            Type
                                          </th>
                                          <th className="amount_due text-white">
                                            Value
                                          </th>
                                          {/* //
                                          {' '}
                                          <th className="amount_paid text-white">
                                            //     Amount Paid
                                            //
                                            {' '}
                                          </th>
                                          //
                                          {' '}
                                          <th className="pending_due text-white">
                                            //     Loan Balance
                                            //
                                            {' '}
                                          </th>
                                          //
                                          {' '}
                                          <th className="status text-white">
                                            //     Status
                                            //
                                            {' '}
                                          </th>
                                          //
                                          {' '}
                                          <th className="action text-white">
                                            //     Action
                                            //
                                            {' '}
                                          </th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {assetDocuments.map((item, index) => (
                                          <tr key={item.id}>
                                            {/* // {index + 1 === schedules.length && ( */}
                                            <td className="sn">
                                              {item?.asset_id}
                                              {/* // <span className="sn"> */}
                                              {/* //   Total */}
                                              {/* // </span> */}
                                            </td>
                                            {/* // )} */}
                                            {/* // {index + 1 !== schedules.length && ( */}
                                            <td className="sn">
                                              {item?.user_id}
                                              {/* // <span className="sn"> */}
                                              {/* //   {index + 1 ?? "---"} */}
                                              {/* // /</td></span> */}
                                            </td>
                                            {/* // )} */}
                                            <td className="date-time">
                                              {item?.type}
                                              {/* //   <span className="date"> */}
                                              {/* //     {schedule.Date ?? "---"} */}
                                              {/* //   </span> */}
                                            </td>
                                            <td className="loan_amount">
                                              <a href={item?.value} target="_blank" rel="noreferrer">Link</a>
                                            </td>
                                            {/* //   {schedule.Principal}
                                            // <td className="interest">
                                            //   {schedule.Interest}
                                            // </td>
                                            // <td className="amount_due">
                                            //   {schedule["Amount Due"]}
                                            // </td>

                                            // <td className="amount_paid">
                                            //   {schedule["Amount Paid"]}
                                            // </td>
                                            // <td className="pending_due">
                                            //   {schedule["Pending Due"] ?? "---"}
                                            // </td>
                                            // <td className="status">
                                            //   {schedule.Status ?? "---"}
                                            // </td>
                                            // <td className="action">
                                            //   {schedule.Date && */}
                                            {/* //     schedule.Status && (
                                            //       <span */}
                                            {/* //         style={{
                                            //           color: "green",
                                            //           cursor: "pointer",
                                            //         }}
                                            //         onClick={() =>
                                            //           this.setState({
                                            //             schedule,
                                            //           })
                                            //         }
                                            //       >
                                            //         View Transactions
                                            //       </span>
                                            //     )}
                                            //   {(!schedule.Date ||
                                            //     !schedule.Status) && (
                                            //     <span>---</span>
                                            //   )}
                                            // </td> */}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row mt-5">
                        <div className="col" id="exportSchedule">
                          <div className="card default-card settings">
                            <Nav className="nav nav-tabs" as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                  className="nav-link active"
                                  eventKey="profile"
                                >
                                  Asset Attributes
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            {assetAttributeValues && (
                              <div className="tab-content">
                                <div className="tab-pane fade show active">
                                  <div className="table-responsive">
                                    <table
                                      className="table"
                                      style={{ textAlign: "center" }}
                                    >
                                      <thead className="bg-secondary">
                                        <tr>
                                          <th className="date-time text-white">
                                            Asset Attribute ID
                                          </th>
                                          <th className="loan_amount text-white">
                                            Asset Attribute Name
                                          </th>
                                          <th className="interest text-white">
                                            Asset Attribute Key
                                          </th>
                                          <th className="amount_due text-white">
                                            Value
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {assetAttributeValues.map(
                                          (item, index) => (
                                            <tr key={item.id}>
                                              <td className="sn">
                                                {item?.asset_attribute_id}
                                              </td>
                                              <td className="sn">
                                                {item?.asset_attribute?.name}
                                              </td>

                                              <td className="date-time">
                                                {item?.asset_attribute?.key}
                                              </td>
                                              <td className="loan_amount">
                                                <a href={item?.value} target="_blank" rel="noreferrer">Link</a>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        {/* <LoanScheduleTransactions
          visible={!!schedule}
          data={schedule}
          onClose={() => this.setState({ schedule: null })} />
        <EditLoan
          visible={!!edit}
          data={edit}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ edit: null })} />
        <CancelLoan
          visible={cancel}
          data={cancel}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ cancel: null })} />
        <AcceptLoan
          visible={action === 'accept'}
          data={[loan]}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ action: null })} /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = { fillUser };

export default connect(mapStateToProps, mapDispatchToProps)(ViewInsurance);
